import { UIText3, IconDocumentsVerified16 } from '@cian/ui-kit';
import React from 'react';

import styles from './Proof.css';

interface IProofProps {
  text: string;
}

export function Proof({ text }: IProofProps) {
  return (
    <div className={styles['proof']}>
      <div className={styles['icon']}>
        <IconDocumentsVerified16 color="primary_100" />
      </div>
      <UIText3 color="black_100">{text}</UIText3>
    </div>
  );
}
